import React, {useState} from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {Picker} from '/component/base/Picker';
import ModalHeader from '/component/layout/ModalHeader';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './PickerModal.style';
import {PickerModalProps} from './PickerModal.types';

export const PickerModal = ({
  items = [],
  selectedItemIndex = 0,
  setSelectedItemIndex = () => {},
}: PickerModalProps) => {
  const {tt} = useTranslation('pickerModal');
  const navigation = useNavigation();

  const [newSelectedItemIndex, setNewSelectedItemIndex] = useState<
    number | undefined
  >(selectedItemIndex);

  const onActionPress = () => {
    setSelectedItemIndex(newSelectedItemIndex);
    navigation.goBack();
  };

  return (
    <ModalHeader
      style={{base: styles.base, headerText: styles.headerText}}
      title={tt('select', 'Select time period')}
      actionLabel={tt('apply', 'Apply')}
      titleVariant="medium"
      onActionPress={onActionPress}
      onClose={navigation.goBack}
      closeIconName="chevron-left">
      <View style={styles.container}>
        <Picker
          items={items}
          selectedItem={Number(newSelectedItemIndex)}
          setSelectedItem={setNewSelectedItemIndex}
        />
      </View>
    </ModalHeader>
  );
};
